export default __webpack_public_path__ + "static/media/mail.2cddd77a.svg";